import { RowItemType, Section, SelectorIdentifier, UIElementType } from '../../models';
import { field } from '../../core/field-schema';
import { required } from '../../core/validator-builders';
import { ComportOption } from '../../../models/location-card.model';
import { foresiteXdSensorChange } from '../../actions';

/**
 * Field IDs enum for consistent reference
 */
enum FieldId {
    Sensor = 'sensor',
}

/**
 * ForeSITE XD Info Configuration Section
 */
export const foreSiteXDInfo: Section = {
    info: {
        id: 'foresite-xd-info-section',
        title: 'ADD_EDIT.FORESITE_XD',
        displayTitle: true,
        expandable: true,
        expanded: false,
        panelClass: 'triton-plus-section',
    },
    rows: [
        // Subtitle row
        {
            info: {
                id: 'subtitle-row',
            },
            items: [
                {
                    id: 'foresite-subtitle',
                    type: RowItemType.UI,
                    uiType: UIElementType.Text,
                    label: 'ADD_EDIT.ADD_EDIT_SUBTITLE',
                    panelClass: 'input-text subtitle-text',
                },
            ],
        },

        // Sensor row
        {
            info: {
                id: 'sensor-row',
                panelClass: 'custom-33p',
            },
            items: [
                field.select<ComportOption, string>(FieldId.Sensor, 'sensor', {
                    placeholder: 'ADD_EDIT.INPUT_PLACEHOLDER_SENSOR',
                    panelClass: 'required',
                    value: 'Radar',
                    validators: [required()],
                    valueMapper: (value) => value.value,
                    displayMapper: (value) => value.text,
                    optionsSelector: SelectorIdentifier.ForeSiteXdSensorOptions,
                    events: {
                        onChange: (sensor: ComportOption) => [foresiteXdSensorChange({ sensorValue: sensor.value })],
                    },
                }),
            ],
        },
    ],
};
